// Foundation JavaScript
// Documentation can be found at: http://foundation.zurb.com/docs
$(document).foundation();

// document ready method
$(function() {
  // // TRIGGERMENU
  // const header = document.querySelector('.page-header'), footer = document.querySelector('.page-footer'), body = document.body;
  // const menuTrigger = document.querySelector('.triggerMenu');
  // if (menuTrigger) menuTrigger.addEventListener('click', e => {
  //   e.preventDefault();	e.stopPropagation();
  //
  //   const pageContentWrap = document.querySelector('.page-content .pc-wrap'),
  //   headerWrap = header.querySelector('.ph-inner'),
  //   footerWrap = footer.querySelector('.pf-inner');
  //
  //   // fix for the scrollbar missing - put a padding-right of the size of the scrollbar
  //   const paddingRight = !body.classList.contains('menu-opened') ? (window.innerWidth - (document.documentElement.clientWidth || document.body.clientWidth)) + 'px' : '';
  //   [headerWrap, pageContentWrap].forEach( item => !item || (item.style.paddingRight = paddingRight) );
  //   if (footerWrap) footerWrap.style.paddingRight = paddingRight;
  //
  //   body.classList.toggle('menu-opened');
  //   menuTrigger.classList.toggle('active');
  // });
  //
  //
  // // close the menu when we click outside it, on the overlay
  // const menuWrapper = header.querySelector('.menu-wrapper'), menuWrapperParent = menuWrapper.parentNode;
  // menuWrapperParent.addEventListener('click', e => {
  //   if (window.innerWidth >= 768 ) {
  //     if ( document.body.classList.contains('menu-opened') && !menuWrapper.contains(e.target) ) {
  //       menuTrigger.click();
  //     }
  //   }
  // });
  //
  //
  // // SCROLL TO NEXT SECTION
  // document.addEventListener('click', e => {
  //   const scrollToNext = e.target.closest('.scroll-to-next-section');
  //   if (scrollToNext) {
  //     e.preventDefault();
  //     const thisSection = scrollToNext.closest('section');
  //     if (thisSection) {
  //       let found = false, current = thisSection.nextElementSibling;
  //       do {
  //         if (current.matches('section')) {
  //           found = true;
  //           const scrollTop = current.getBoundingClientRect().top + window.pageYOffset;
  //           $('html, body').animate({
  //             scrollTop
  //           }, 1000);
  //         }
  //         current = current.nextElementSibling;
  //       } while (!found && current);
  //     }
  //   }
  // });
  //
  // you can use lazy-loaded slick sliders like this:
  // $('.my-slider').chLazySlick({ etc })
  // that is, instead of "slick()" use "chLazySlick". You still need the slick.js library in gulp!
  // // Infinite Scroll
  // $('.js-infinite').chInfiniteScroll({
  //   containerSelector: '.js-infinite',
  //   itemSelector: 'article',
  //   paginationContainerSelector: '.page-pagination',
  //   paginationLinksSelector: '.page-pagination a',
  //   loadButton: '.page-pagination a',
  //   loadOnScroll: true,
  //   // numberOfPages: false,
  //   // currentPageNumber: 1,
  // });
  // // Sticky Header - please enable jquery.sticky-header.js in gulpfile.js
  // $('.page-header').stickyHeader({
  //   offset: 100,
  //   positionStickyWorkaround: true, // use this if the header height changes when pinned
  // });
});
